import { Component, uiElement, uiElements, uiEvent } from "@kluntje/core";
import { addClass, removeClass } from "@kluntje/js-utils/lib/dom-helpers";
import { FormField } from "Components/abstract/wec-e-form-field/wec-e-form-field";
import { FormFieldSubmitValue } from "Components/abstract/wec-e-form-field/wec-e-form-field.types";
import { renderLoadingBounceElement } from "Components/wec-e-loading-bounce/wec-e-loading-bounce.template";
import { ERROR, LOADING, SUCCESS } from "Constants/cssClasses";
import { render } from "lit-html";
import DebuggerService from "Services/DebuggerService";

export type FormFieldType = string;

export class WECForm extends Component {
  @uiElement(".wec-m-form__form")
  form: HTMLFormElement;

  @uiElements(".wec-m-form__input")
  formFields: Array<FormField<FormFieldType>>;

  loadingBounce?: HTMLElement;

  get submitUrl(): string {
    return this.getAttribute("submit-url") || "";
  }

  get submitData(): Array<FormFieldSubmitValue<FormFieldType>> {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return this.formFields.map(formField => formField.submitData).filter(submitData => submitData !== null);
  }

  @uiEvent("form", "submit")
  handleSubmit(e: Event) {
    e.preventDefault();
    const allFieldsValid = this.validateFormFields();

    if (allFieldsValid === false) return;

    this.postData();
  }

  validateFormFields(): boolean {
    const validityStates = this.formFields.map(formField => {
      formField.validate();
      return formField.isValid;
    });
    return validityStates.filter(isValid => isValid === false).length === 0;
  }

  async postData() {
    const submitData = this.submitData;

    if (submitData.length === 0 || this.submitUrl === "") return;

    this.renderLoadingBounce();
    addClass(this, LOADING);

    try {
      const response = await fetch(this.submitUrl, {
        method: "POST",
        body: JSON.stringify(submitData),
      });

      if (response.ok) {
        this.handleSuccess();
      } else {
        this.handleError(response.statusText);
      }
    } catch (e) {
      this.handleError(e);
    }
  }

  protected renderLoadingBounce() {
    if (this.loadingBounce === undefined) {
      this.loadingBounce = document.createElement("div");
      render(renderLoadingBounceElement(), this.loadingBounce);

      this.appendChild(this.loadingBounce);
    }
  }

  protected handleError(errorMessage: string) {
    DebuggerService.error("Form Default Error: ", errorMessage);
    removeClass(this, LOADING);
    addClass(this, ERROR);
  }

  protected handleSuccess() {
    removeClass(this, LOADING);
    addClass(this, SUCCESS);
  }
}

customElements.define("wec-m-form", WECForm);
